import React, { useState, useEffect } from 'react'
import { Checkbox } from 'primereact/checkbox';

import './style.css'

export default function PrintGroupItem(props) {

  const { control, printLayer, printGroup, printDetails, groupItem, config, actions } = props;
  const { selectedPrints, setSelectedPrints } = props;
  const { viewer, mainMap, dispatch, Models } = config;

  const onSelectedPrintChange = (e) => {
    const prints = [...selectedPrints];

    if (e.checked)
      prints.push(e.value);
    else
      prints.splice(prints.indexOf(e.value), 1);

    setSelectedPrints(prints);
  }

  return (
    <ul>
      <li>
        <span><b>{groupItem.title}</b></span>
        {(groupItem.children && groupItem.children.length > 0) &&
          <React.Fragment>
            {groupItem.children.map(item => {
              return (
                <PrintGroupItem
                  key={item.id}
                  config={config}
                  actions={actions}
                  printGroup={printGroup}
                  printDetails={printDetails}
                  groupItem={item}
                  selectedPrints={selectedPrints}
                  setSelectedPrints={setSelectedPrints}
                />
              )
            })}
          </React.Fragment>
        }
        {(groupItem.prints && groupItem.prints.length > 0) &&
          <ul>
            {groupItem.prints.map(print => {
              return (
                <li key={print.id}>
                  {printDetails.allow_selection &&
                    <Checkbox value={print.uuid}
                      onChange={onSelectedPrintChange} checked={selectedPrints.includes(print.uuid)} />
                  }
                  <span className="task-name ml-1">{print.title}</span>
                </li>
              )
            })}
          </ul>
        }
      </li>
    </ul>
  )
}